import { render } from "./ChatHomeView.vue?vue&type=template&id=0597110f"
import script from "./ChatHomeView.vue?vue&type=script&lang=js"
export * from "./ChatHomeView.vue?vue&type=script&lang=js"

import "./ChatHomeView.vue?vue&type=style&index=0&id=0597110f&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__